module.exports = __webpack_public_path__ + "img/top_slider_202504_acseries.eaac8301.jpg";